module.exports = __webpack_public_path__ + "img/boqinspect2_7-8-2021.b69b2a81.jpg";